import { render } from "./DataTableRow.vue?vue&type=template&id=32109f9a"
import script from "./DataTableRow.vue?vue&type=script&lang=js"
export * from "./DataTableRow.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__